export default "__VITE_ASSET__Cs3SU3HQ__"